<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <!-- 결제방법 form s.-->
            <div class="table-area">
                <div class="table-b">
                    <div class="el-search-form">
                        <el-form size="mini" label-width="80px">
                            <el-row :gutter="24">
                                <el-col :span="12">
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="사업자등록번호">
                                                <el-input type="text" v-model="form.businessNo"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="24">
                                        <el-col :span="15">
                                            <el-form-item label="대표자명">
                                                <el-input type="text" v-model="form.keyManNm"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <div class="grid-content bg-purple"></div>
                                </el-col>
                                <el-col :span="12">
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="사업장명">
                                                <el-input type="text" v-model="form.companyNm"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="업종">
                                                <el-input type="text" v-model="form.territory"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="업태">
                                                <el-input type="text" v-model="form.businessStatus"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item label="주소">
                                        <el-row>
                                            <el-col>
                                                <el-row>
                                                    <el-col :span="4">
                                                        <el-input type="text" v-model="form.zipCd" ></el-input>
                                                    </el-col>
                                                    <el-col :span="4">
                                                        <el-button type="primary" icon="el-icon-search"  @click="addrOpenPopUp">
                                                        </el-button>
                                                    </el-col>
                                                    <el-col :span="16">
                                                        <el-input type="text" v-model="form.addr1" ></el-input>
                                                    </el-col>
                                                </el-row>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col>
                                                <el-row :gutter="24">
                                                    <el-col :span="24">
                                                        <el-input type="text" v-model="form.addr2"></el-input>
                                                    </el-col>
                                                </el-row>
                                            </el-col>
                                        </el-row>
                                    </el-form-item>
                                </el-col>
                            </el-row>   
                        </el-form>
                    </div>
                </div>
            </div>
            <!-- 결제방법 form e.-->
            
            <div class="btn-wrap btn-type1 clearfix">
                <button class="btn-size btn-gray fl_right" @click="btnSave" v-show="grantInsert">
                <span class="btn-icon">
                    <i class="fas fa-save"></i>
                </span>
                저장
                </button>
            </div>
                                   
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer'    

/**
 * * mixins
 */
import Modal from './index.js';
import common from '@/mixin/lucoms';

/**
 * 콤마표시
 * @param {*} val 
 */
 function comma(val){
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


 export default {
    components: {Layout, AgGridVue},
    props: {
        data: {
            type: Object,
            required: false
        }
    },
    mixins: [Modal, common],
    data() {
        return {
            form: {
                orderId: '', /** 주문번호 */
                custId: '', /** 고객ID */
                companyNm: '', /** 사업장명 */
                businessNo: '', /** 사업자번호 */
                keyManNm: '', /** 대표자명 */ 
                territory: '', /** 업종 */ 
                businessStatus: '', /** 업태 */ 
                zipCd: '', /**  */ 
                addr1 : '', /**  */ 
                addr2 : '' /**  */ 
            },
            payBankOpt: [], /** 입금은행 */
            billYnRadio: [], /** 계산서 발생유무 */
            grantInsert: true
        }
    },
    computed: {
        title() {
            return `계산서발행정보`;
        }
    },
    mounted() {
        
        this.getCombo();
        this.selectOrderDetail();
        const vOrderAmt = this.form.orderAmt;
        this.form.orderAmt = comma(vOrderAmt);

        console.log('pop mount data: ', this.data, this.billYnRadio)
        
    },
    methods: {
        onReady(params) {
            
        },
        selectOrderDetail(){
            const vm = this
            if(!this.data.orderId){
                return false
            }

            const vform = {
                orderId: this.data.orderId,
                sortType: ''
            }
            this.$store.commit('loading')
            // console.log('selectOrderDetail : ', vform) 
            this.$http.post(("/api/asMng/mateSaleList/selectItem"), vform
                ).then(response => {
                console.log('selectOrderDetail resp: ', response)
                if(response.data.accountPrint && response.data.accountPrint.length>0){
                    vm.form = response.data.accountPrint[0]
                }

                vm.form.billYn = vm.form.billYn==='Y' ? '유' : '무' 
                vm.form.zipCd = vm.form.zipCd || ''
                
            }).finally(() => {
                this.$store.commit('finish')
            });
      },
      getCombo(param) {
        // 결제은행 : PayBank 2레벨
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 106}})
            .then(response => {
                this.payBankOpt = response.data || []
                this.payBankOpt.unshift({key:'', value:'선택'})

            });
        
        // 계산서발행유무 : BillYn 2레벨
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 131}})
            .then(response => {
                this.billYnRadio = response.data || []

                // console.log('billYnRadio response.data: ', response.data)
            });    
    
        },
        addrOpenPopUp() {
            const vm = this;
            // eslint-disable-next-line no-undef
            new daum.Postcode({
                oncomplete: (data) => {
                    var fullAddr = data.address; //최종 주소 변수
                    var extraAddr = ''; // 조합형 주소 변수
              
                    if(data.userSelectedType === 'R') {
                        if(data.bname) {
                            extraAddr += data.bname;
                        }
                        if(data.buildingName) {
                            extraAddr += (extraAddr ? ', '+ data.buildingName : data.buildingName);
                        }
                        fullAddr += (extraAddr ? ' ('+ extraAddr + ')' : '');
                    } else {
                        fullAddr = data.jibunAddress;
                    }
                    console.log(data)
                    vm.form.zipCd = data.zonecode;
                    vm.form.addr1 = fullAddr;
                    vm.form.addr2 = ''; // 초기화
                }
            }).open();
        },
        btnSave(){
            // 저장처리
            const vm = this;

            if(!this.grantInsert){
                this.$swal({ type: 'warning', text: '편집권한이 없습니다.' });
                return false;
            }

            if(this.form.businessNo === ''){
                this.$swal({ type: 'warning', text: '사업자등록번호를 입력해 주십시오.' });
                return false;
            }

            if(this.form.companyNm === ''){
                this.$swal({ type: 'warning', text: '사업장명을 입력해 주십시오.' });
                return false;
            }

            if(this.form.keyManNm === ''){
                this.$swal({ type: 'warning', text: '대표자명을 입력해 주십시오.' });
                return false;
            }

            if(this.form.territory === ''){
                this.$swal({ type: 'warning', text: '업종을 입력해 주십시오.' });
                return false;
            }

            if(this.form.businessStatus === ''){
                this.$swal({ type: 'businessStatus', text: '업태를 입력해 주십시오.' });
                return false;
            }

            if(this.form.zip_cd === ''){
                this.$swal({ type: 'zip_cd', text: '우편번호를 입력해 주십시오.' });
                return false;
            }

            
            if(this.form.addr1 === ''){
                this.$swal({ type: 'warning', text: '주소를 입력해 주십시오.' });
                return false;
            }

            if(this.form.addr2 === ''){
                this.$swal({ type: 'warning', text: '주소를 입력해 주십시오.' });
                return false;
            }

            this.$swal({
                type: 'warning',
                text: `계산서발행정보를 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    let vTelNo = vm.form.subTelNo || '';
                    if(vTelNo && vTelNo.length > 0){
                        vTelNo = vTelNo.replace(/[^0-9]/g, '');
                    }

                    let vHpNo = vm.form.subHpNo || '';
                    if(vHpNo && vHpNo.length > 0){
                        vHpNo = vHpNo.replace(/[^0-9]/g, '');
                    }

                    let vBoundTelNo = vm.form.boundTelNo || '';
                    if(vBoundTelNo && vBoundTelNo.length > 0){
                        vBoundTelNo = vBoundTelNo.replace(/[^0-9]/g, '');
                    }

                    const vform0 = {
                        ...vm.form,
                        telNo: vTelNo,
                        hpNo: vHpNo,
                        boundTelNo: vBoundTelNo
                    }
                    const vform = JSON.parse(JSON.stringify(vform0))
                    
                    console.log('vform save : ', vform)

                    this.$store.commit('loading')
                    this.$http.put("/api/asMng/mateSaleList/saveBill", vform)
                        .then(response => {
                            this.$swal({ type: 'success', text: '계산서발행정보가 저장되었습니다' });
                    
                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: '계산서발행정보의 저장에 실패 했습니다.' })
                        })
                        .finally(() => {
                            this.$store.commit('finish')

                            this.$emit('close', param)
                            this.closeModal()
                        });

                }
            });


        },
        isAuth(){
            // 계산서발행정보 등록권한

            this.grantInsert = false;
            const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===191);
            let Editable = false; // 편집권한
            if(auth && auth.length > 0){
                Editable = auth[0].grantInsert === 'Y' ? true : false ;
            }

            this.grantInsert = true;
            return true;
        },


    }
 }

</script>

<style lang="scss" scoped>
.modal .pop-content{
    padding: 0px 26px 25px 26px;
}
</style>